/**
 * 角色管理
 * 角色管理
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import RoleVo from './RoleVo';




  /**
   * The PagingRoleVo model module.
   * @module role/model/PagingRoleVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PagingRoleVo</code>.
   * @alias module:role/model/PagingRoleVo
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>PagingRoleVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:role/model/PagingRoleVo} obj Optional instance to populate.
   * @return {module:role/model/PagingRoleVo} The populated <code>PagingRoleVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'rows')) {
        obj['rows'] = ApiClient.convertToType(data['rows'], [RoleVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'total')) {
        obj['total'] = ApiClient.convertToType(data['total'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 本页数据
   * @member {Array.<module:role/model/RoleVo>} rows
   */
  exports.prototype['rows'] = undefined;
  /**
   * 总记录数
   * @member {Integer} total
   */
  exports.prototype['total'] = undefined;



  export default exports;
;


